import { LeftPane } from 'components/layout';
import { ROUTE_EDIT_PROFILE, ROUTE_MY_PROFILE } from 'constant/routes';
import compose from 'lodash.flowright';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';

import EditProfile from './editProfile';
import MyProfile from './myProfile';

export function profileRoute() {
  return (
    <>
      <LeftPane title="Profile">
        <Switch>
          <Route component={MyProfile} exact path={ROUTE_MY_PROFILE} />
          <Route component={EditProfile} exact path={ROUTE_EDIT_PROFILE} />
          {/* Fallback for non-existing pages */}
          <Route>
            <Redirect to={ROUTE_MY_PROFILE} />
          </Route>
        </Switch>
      </LeftPane>
    </>
  );
}

export default compose(withRouter)(profileRoute);
